import {combineReducers} from "redux"

import authReducer from "../pages/Auth/reducers/authReducer"
import profileReducer from "../pages/Profile/reducers/profileReducer"
import settingsReducer from "../pages/Settings/reducers/settingsReducer"
import calendarDataReducer from "../pages/TimeTracker/reducers/calendarDataReducer"
import reportsPageReducer from "../pages/Reports/reducers/reportsPageReducer"
import dashboardNotificationsReducer from "../pages/Notifications/reducers/dashboardNotificationsReducer"
import userNotificationsReducer from "../pages/Notifications/reducers/userNotificationsReducer"
import salaryHistoryReducer from "../pages/SalaryHistory/reducers/salaryHistoryReducer"
import paymentReportsReducer from "../pages/PaymentReports/reducers/paymentReportsReducer"
import {bonusReducer} from "../pages/SalaryHistory/reducers/bonusHistoryReducer"
import navigationReducer from "../layouts/Navs/reducers/navigationReducer"
import {entityCountSlice} from "../hooks/common/useNavCount"
import BonusEarnReducer from "../pages/Reports/reducers/BonusEarnReducer"
import SalaryEarnReducer from "../pages/Reports/reducers/SalaryEarnReducer"
import OvertimeEarnReducer from "../pages/Reports/reducers/OvertimeEarnReducer"
import {newcoinsTransactionsReducer} from "../pages/SalaryHistory/reducers/newcoinsHistoryReducer"
import {tableDataSlice} from "../hooks/common/useTableData"
import {productsApi} from "../api/products"
import {equipmentApi} from "../api/equipment"
import {auditLogsApi} from "../api/auditLogs"
import {coinsRelatedApi, salaryRelatedApi, timeRelatedApi} from "../api/base"
import {projectsApi} from "../api/projects"
import {clientsApi} from "../api/clients"
import {employeePositionsApi} from "../api/employeePositions"
import createProductReducer from "../pages/CreateProduct/reducers/createProductReducer"
import viewProductReducer from "../pages/ViewProduct/reducers/viewProductReducer"
import personalPurchaseHistoryReducer from "../pages/PersonalPurchaseHistory/reducers/personalPurchaseHistoryReducer"
import {usersApi} from "../api/users"
import {rolesApi} from "../api/roles"
import {onboardingsApi} from "../api/onboardings"
import {googleIntegrationApi} from "../api/googleIntegration"
import {publicHolidayCalendarsApi} from "../api/publicHolidayCalendars"
import {performanceReviewsApi} from "../api/performanceReviews"

/**
 * @desc Reducer function that invokes every reducer inside the passed object.
 * @const
 * @type {object}
 */
const rootReducer = combineReducers({
    auth: authReducer,
    profile: profileReducer,
    settings: settingsReducer,
    calendarData: calendarDataReducer,
    reportsPage: reportsPageReducer,
    dashboardNotifications: dashboardNotificationsReducer,
    userNotifications: userNotificationsReducer,
    salaryHistory: salaryHistoryReducer,
    bonuses: bonusReducer,
    newcoinsTransactions: newcoinsTransactionsReducer,
    tableData: tableDataSlice.reducer,
    entityCounts: entityCountSlice.reducer,
    [auditLogsApi.reducerPath]: auditLogsApi.reducer,
    [googleIntegrationApi.reducerPath]: googleIntegrationApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [equipmentApi.reducerPath]: equipmentApi.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [clientsApi.reducerPath]: clientsApi.reducer,
    [onboardingsApi.reducerPath]: onboardingsApi.reducer,
    [rolesApi.reducerPath]: rolesApi.reducer,
    [employeePositionsApi.reducerPath]: employeePositionsApi.reducer,
    [coinsRelatedApi.reducerPath]: coinsRelatedApi.reducer,
    [salaryRelatedApi.reducerPath]: salaryRelatedApi.reducer,
    [timeRelatedApi.reducerPath]: timeRelatedApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [publicHolidayCalendarsApi.reducerPath]: publicHolidayCalendarsApi.reducer,
    [performanceReviewsApi.reducerPath]: performanceReviewsApi.reducer,
    createProduct: createProductReducer,
    navigation: navigationReducer,
    paymentReports: paymentReportsReducer,
    earnInfo: SalaryEarnReducer,
    bonusInfo: BonusEarnReducer,
    overtimeInfo: OvertimeEarnReducer,
    personalPurchaseHistory: personalPurchaseHistoryReducer,
    viewProduct: viewProductReducer,

})

export default rootReducer
